import React from 'react';
import BuscarDoctor from './buscar_doctor';
import Axios from 'axios';
import Core from './funciones_extras';
import Alertify from 'alertifyjs';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import '../css/gestion-pacientes.css';

const estadoInicial = {
    nombre: '',
    apellido: '',
    cedula: '',
    telefono: '',
    correo_electronico: '',
    sexo: '',
    especialidad: '',
};

class DoctorFormulario extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            vista: 'formulario',
            especialidades: [],
            cargandoEspecialidades: true,
            guardando: false,
            form: { ...estadoInicial },
        };
    }

    componentDidMount() {
        this.cargarEspecialidades();
    }

    cargarEspecialidades = () => {
        this.setState({ cargandoEspecialidades: true });
        Core.listar_especialidades()
            .then((data) => {
                this.setState({
                    especialidades: Array.isArray(data) ? data : [],
                    cargandoEspecialidades: false,
                });
            })
            .catch(() => {
                this.setState({ cargandoEspecialidades: false });
            });
    };

    irBuscarDoctor = () => {
        this.setState({ vista: 'buscar_doctor' });
    };

    actualizarCampo = (e) => {
        const { name, value } = e.target;
        this.setState((prev) => ({
            form: { ...prev.form, [name]: value },
        }));
    };

    setTelefono = (valor) => {
        this.setState((prev) => ({
            form: { ...prev.form, telefono: valor || '' },
        }));
    };

    limpiarFormulario = () => {
        this.setState({ form: { ...estadoInicial } });
    };

    guardar_doctor = (e) => {
        if (e && e.preventDefault) e.preventDefault();
        if (this.state.guardando) return;

        const { form } = this.state;
        const nombre = (form.nombre || '').trim();
        const apellido = (form.apellido || '').trim();
        const cedula = (form.cedula || '').trim();
        const telefono = (form.telefono || '').trim();
        const correo_electronico = (form.correo_electronico || '').trim();
        const sexo = form.sexo || '';

        if (!nombre || !apellido || !cedula || !telefono || !sexo) {
            Alertify.error('Complete todos los campos requeridos');
            return;
        }
        if (!correo_electronico) {
            Alertify.error('Indique el correo del odontólogo para enviarle el enlace de registro');
            return;
        }

        this.setState({ guardando: true });

        const urlBase = Core.url_base.endsWith('/') ? Core.url_base.slice(0, -1) : Core.url_base;
        const urlFrontend = typeof window !== 'undefined' && window.location ? window.location.origin : '';

        Axios.post(`${urlBase}/api/crear_doctor_completo`, {
            nombre,
            apellido,
            cedula,
            telefono,
            especialidad: form.especialidad || null,
            sexo,
            correo_electronico,
            url_frontend: urlFrontend || null,
        })
            .then((res) => {
                const inv = res.data && res.data.invitacion_correo;
                if (inv && inv.enviada) {
                    Alertify.success('Doctor guardado. Se envió el correo con el enlace para crear su acceso.');
                } else if (inv && inv.motivo === 'error_correo') {
                    Alertify.warning('Doctor guardado, pero no se pudo enviar el correo. Revise la configuración del servidor.');
                } else if (inv && inv.motivo === 'sin_url_frontend') {
                    Alertify.warning('Doctor guardado, pero falta la URL del sistema para el enlace del correo.');
                } else if (inv && inv.motivo === 'error_invitacion') {
                    Alertify.warning('Doctor guardado, pero no se pudo crear la invitación (¿migraciones ejecutadas?).');
                } else {
                    Alertify.success('Doctor guardado con éxito');
                }
                this.setState({ guardando: false, vista: 'buscar_doctor', form: { ...estadoInicial } });
            })
            .catch((error) => {
                const errorMessage =
                    error.response?.data?.message ||
                    error.response?.data?.error ||
                    'Error al guardar el doctor';
                Alertify.error(errorMessage);
                this.setState({ guardando: false });
            });
    };

    renderField = (id, label, optional, children) => (
        <div className="col-md-6 agregar-paciente-field">
            <label htmlFor={id} className="agregar-paciente-label">
                {label}
                {optional && <span className="agregar-paciente-label-optional"> (opcional)</span>}
            </label>
            {children}
        </div>
    );

    render() {
        if (this.state.vista === 'buscar_doctor') {
            return <BuscarDoctor />;
        }

        const { form, guardando, cargandoEspecialidades, especialidades } = this.state;
        const lang = (Core.lenguaje && Core.lenguaje.agregar_doctores) || {};
        const langRoot = Core.lenguaje || {};
        const titulo = langRoot.agregar_doctor || lang.nombre || 'Agregar doctor';
        const listaEsp = especialidades.length > 0
            ? especialidades
            : (Core.lenguaje && Core.lenguaje.especialidades
                ? Core.lenguaje.especialidades.map((nombre, i) => ({ id: i, nombre }))
                : []);

        return (
            <div className="col-12 col-md-10 listado-pacientes-page agregar-paciente-page kadosh-form-page">
                <div className="listado-pacientes-hero">
                    <div className="listado-pacientes-hero-info">
                        <div className="listado-pacientes-hero-icon">
                            <i className="fas fa-user-md" />
                        </div>
                        <div>
                            <h1 className="listado-pacientes-hero-title">{titulo}</h1>
                            <p className="listado-pacientes-hero-subtitle">
                                Registre un odontólogo y envíele un enlace por correo para crear su acceso
                            </p>
                            <div className="agregar-paciente-nav">
                                <button
                                    type="button"
                                    className="agregar-paciente-nav-link agregar-paciente-nav-link--ghost"
                                    onClick={this.irBuscarDoctor}
                                >
                                    <i className="fas fa-search" />
                                    {lang.buscar_doctor || 'Buscar doctor'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="agregar-paciente-form-card">
                    <form className="agregar-paciente-form-body" onSubmit={this.guardar_doctor} noValidate>
                        <div className="agregar-paciente-alert" style={{ background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1e40af' }}>
                            <i className="fas fa-envelope" />
                            <span>
                                Al guardar, se envía un correo con enlace para que el doctor defina usuario y contraseña
                                (acceso clínico, sin módulos financieros).
                            </span>
                        </div>

                        <div className="agregar-paciente-section">
                            <h2 className="agregar-paciente-section-title">
                                <i className="fas fa-id-card" />
                                Datos personales
                            </h2>
                            <div className="row">
                                {this.renderField('nombre', lang.nombre === 'Agregar doctor' ? 'Nombre' : (lang.nombre || 'Nombre'), false,
                                    <input
                                        type="text"
                                        id="nombre"
                                        name="nombre"
                                        className="agregar-paciente-input form-control"
                                        value={form.nombre}
                                        onChange={this.actualizarCampo}
                                        placeholder="Nombre del doctor"
                                        autoComplete="given-name"
                                        required
                                    />
                                )}
                                {this.renderField('apellido', lang.apellido || 'Apellido', false,
                                    <input
                                        type="text"
                                        id="apellido"
                                        name="apellido"
                                        className="agregar-paciente-input form-control"
                                        value={form.apellido}
                                        onChange={this.actualizarCampo}
                                        placeholder="Apellido"
                                        autoComplete="family-name"
                                        required
                                    />
                                )}
                                {this.renderField('cedula', lang.cedula || 'Cédula', false,
                                    <input
                                        type="text"
                                        id="cedula"
                                        name="cedula"
                                        className="agregar-paciente-input form-control"
                                        value={form.cedula}
                                        onChange={this.actualizarCampo}
                                        placeholder="000-0000000-0"
                                        required
                                    />
                                )}
                                {this.renderField('sexo', 'Sexo', false,
                                    <select
                                        id="sexo"
                                        name="sexo"
                                        className="agregar-paciente-select form-control"
                                        value={form.sexo}
                                        onChange={this.actualizarCampo}
                                        required
                                    >
                                        <option value="">Seleccionar sexo…</option>
                                        <option value="M">Masculino</option>
                                        <option value="F">Femenino</option>
                                    </select>
                                )}
                            </div>
                        </div>

                        <div className="agregar-paciente-section">
                            <h2 className="agregar-paciente-section-title">
                                <i className="fas fa-address-book" />
                                Contacto
                            </h2>
                            <div className="row">
                                <div className="col-md-6 agregar-paciente-field">
                                    <label className="agregar-paciente-label" htmlFor="telefono">
                                        {lang.telefono || 'Teléfono'} *
                                    </label>
                                    <div className="agregar-paciente-phone">
                                        <PhoneInput
                                            id="telefono"
                                            defaultCountry="DO"
                                            placeholder="809-000-0000"
                                            value={form.telefono}
                                            onChange={this.setTelefono}
                                            numberInputProps={{ className: 'PhoneInputInput form-control' }}
                                        />
                                    </div>
                                </div>
                                {this.renderField('correo_electronico', lang.correo_electronico || 'Correo electrónico', false,
                                    <input
                                        type="email"
                                        id="correo_electronico"
                                        name="correo_electronico"
                                        className="agregar-paciente-input form-control"
                                        value={form.correo_electronico}
                                        onChange={this.actualizarCampo}
                                        placeholder="odontologo@correo.com"
                                        autoComplete="email"
                                        required
                                    />
                                )}
                            </div>
                        </div>

                        <div className="agregar-paciente-section">
                            <h2 className="agregar-paciente-section-title">
                                <i className="fas fa-stethoscope" />
                                Especialidad
                            </h2>
                            <div className="row">
                                <div className="col-md-12 agregar-paciente-field">
                                    <label htmlFor="especialidad" className="agregar-paciente-label">
                                        {lang.especialidad || 'Especialidad'}
                                        <span className="agregar-paciente-label-optional"> (opcional)</span>
                                    </label>
                                    <select
                                        id="especialidad"
                                        name="especialidad"
                                        className="agregar-paciente-select form-control"
                                        value={form.especialidad}
                                        onChange={this.actualizarCampo}
                                        disabled={cargandoEspecialidades}
                                    >
                                        <option value="">
                                            {cargandoEspecialidades ? 'Cargando especialidades…' : 'Seleccionar especialidad…'}
                                        </option>
                                        {listaEsp.map((esp) => (
                                            <option key={esp.id != null ? esp.id : esp.nombre} value={esp.nombre}>
                                                {esp.nombre}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="agregar-paciente-actions">
                            <button
                                type="button"
                                className="agregar-paciente-btn agregar-paciente-btn--ghost"
                                onClick={this.limpiarFormulario}
                                disabled={guardando}
                            >
                                <i className="fas fa-eraser" />
                                Limpiar
                            </button>
                            <button
                                type="button"
                                className="agregar-paciente-btn agregar-paciente-btn--ghost"
                                onClick={this.irBuscarDoctor}
                                disabled={guardando}
                            >
                                <i className="fas fa-search" />
                                {lang.buscar_doctor || 'Buscar doctor'}
                            </button>
                            <button
                                type="submit"
                                className="agregar-paciente-btn agregar-paciente-btn--primary"
                                disabled={guardando}
                            >
                                {guardando ? (
                                    <><i className="fas fa-spinner fa-spin" /> Guardando…</>
                                ) : (
                                    <><i className="fas fa-save" /> {lang.guardar ? (lang.guardar.charAt(0).toUpperCase() + lang.guardar.slice(1)) : 'Guardar doctor'}</>
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export default DoctorFormulario;
